import React from 'react';
import { Link } from 'react-router-dom';
import voca from 'voca';
import CustomReactPaginate from '../../../common/custom/CustomReactPaginate';
import showAlert from '../../../common/utils/alert';
import { convertTimeStampToDate } from '../../../common/utils/dateUtils';

function ZapierApiList({ version, actions, projectId, externalapi, page, limit, onPageChange }) {
  const { deleteExternalApi, cloneExternalApi } = actions;
  const handleDelete = (uuid) => {
    const text = "You won't be able to revert this.";
    const preConfirm = () => {
      deleteExternalApi({ uuid, projectId, version });
    };
    const confirmButtonText = 'Yes, delete it!';
    showAlert(text, preConfirm, confirmButtonText);
  };
  const handleClone = (externalapi) => {
    const {
      externalApiName,
      bodyDataFrom,
      sendFormData,
      collectionName,
      isUpdateItemWithResponse,
      donotPersistResponseData,
      collectionMapping,
      bodyRawJSON,
      bodyCustomJSON,
      bodyCollectionMapping,
      requestDataJsonType,
      setting,
      responseDataMapping,
      externalApiType,
      timeout,
    } = externalapi;
    const data = {
      externalApiName,
      projectId,
      version,
      bodyDataFrom,
      sendFormData,
      collectionName,
      isUpdateItemWithResponse,
      donotPersistResponseData,
      collectionMapping,
      bodyRawJSON,
      bodyCustomJSON,
      bodyCollectionMapping,
      requestDataJsonType,
      setting,
      responseDataMapping,
      externalApiType,
      timeout,
    };
    const text = 'Do you want to clone this Zapier?';

    const preConfirm = () => {
      cloneExternalApi(data).then(() => {
        actions.loadExternalApis({
          projectId,
          version,
          page: page,
          limit: limit,
          externalApiType: externalApiType,
        });
      });
    };
    const confirmButtonText = 'Yes, Clone it!';
    showAlert(text, preConfirm, confirmButtonText);
  };
  const getCollectionTitle = (collectionName) => {
    const { collections, inMemoryCollections } = externalapi;
    const collection = [...collections, ...inMemoryCollections].find(
      (e) => e.collectionName === collectionName,
    );
    return collection ? collection.collectionTitle : collectionName;
  };

  const generateEditUrl = (externalapi) => {
    return (
      <Link
        to={`/2.0/externalapi/${version}/v/${projectId}/zapier/${externalapi.uuid}/update`}
        className="btn btn-xs btn-primary"
        title={`Edit ${externalapi.externalApiName}`}
      >
        <i className="wb webconnect-pencil"></i>
      </Link>
    );
  };
  const { externalApis, deleteExternalApiPending, totalExternalApisPages } = externalapi;
  if (externalApis && externalApis.length > 0) {
    return (
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-sm table-word-break connector-list">
          <thead>
            <tr>
              <th>Name</th>
              <th>Zap Status</th>
              <th>Req. Collection</th>
              <th>Created Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {externalApis.map((externalapi) => (
              <tr key={externalapi.uuid} className="text-left td-align-middle">
                <td title={externalapi.externalApiName}>
                  {voca.truncate(externalapi.externalApiName, 30)}
                </td>
                <td>{externalapi.setting.enabled ? 'ON' : 'OFF'}</td>
                <td title={getCollectionTitle(externalapi.collectionName)}>
                  {voca.truncate(getCollectionTitle(externalapi.collectionName), 25)}
                </td>
                <td>{convertTimeStampToDate(externalapi.createdAt)}</td>
                <td className="text-right">
                  {generateEditUrl(externalapi)}
                  &nbsp;
                  <button
                    className="btn btn-xs btn-theme-submit"
                    onClick={() => handleClone(externalapi)}
                    title={`Clone ${externalapi.externalApiName}`}
                  >
                    <i className="wb webconnect-clone"></i>
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-xs btn-theme-delete"
                    onClick={() => handleDelete(externalapi.uuid)}
                    disabled={deleteExternalApiPending}
                    title={`Delete ${externalapi.externalApiName}`}
                  >
                    <i className="wb webconnect-trash-solid"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {totalExternalApisPages > 1 && (
          <CustomReactPaginate
            totalPages={totalExternalApisPages}
            pageRangeDisplayed={10}
            marginPagesDisplayed={2}
            page={page}
            limit={limit}
            onPageChange={onPageChange}
          />
        )}
      </div>
    );
  } else return <div className="alert">No Zaps found! Please create one if needed.</div>;
}

export default ZapierApiList;
